import { render } from "./MainFrameWork.vue?vue&type=template&id=3a0155d8"
import script from "./MainFrameWork.vue?vue&type=script&lang=js"
export * from "./MainFrameWork.vue?vue&type=script&lang=js"

import "./MainFrameWork.vue?vue&type=style&index=0&id=3a0155d8&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__